<template>
	<div class="w-100">
    <transition name="fade">
      <div>
        <div class="bg-green rounded-6 px-4 py-4 mb-3">
          <p class="mb-3 body-2-2 font-bold text-18 text-white">{{$t("hotel.reservation-summary")}}</p>
          <template v-if="show_room">
            <div class="mb-3 bg-white rounded-4" :class="!isMerchantMaldiveOhip ? 'p-3' : 'py-3'">
              <div class="d-flex mb-3 pb-3 border-b-form align-items-center justify-content-between" :class="{'px-3 bg-light-page' : isMerchantMaldiveOhip}">
                <div class="text-center">
                  <p class="mb-0 body-3">Check-in</p>
                  <p class="mb-0 text-16 font-lato">{{$formatDateWithoutMonth(getBeFilter.date.check_in)}}</p>
                </div>
                <div class="text-center">
                  <p class="mb-0 text-12 font-lato">{{ `${totalNight} ${$pluralWord(totalNight, 'night')}` }}</p>
                  <svg height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.0926 7.38514C18.0926 7.14157 17.9952 6.91748 17.8004 6.73237L11.3408 0.292288C11.1264 0.0779435 10.9218 0 10.688 0C10.2106 0 9.84034 0.350746 9.84034 0.837891C9.84034 1.07172 9.91832 1.29581 10.0742 1.45169L12.2566 3.67309L16.1245 7.20003L16.3194 6.71288L13.1822 6.51802H0.857379C0.350746 6.51802 0 6.87852 0 7.38514C0 7.89178 0.350746 8.25227 0.857379 8.25227H13.1822L16.3194 8.05741L16.1245 7.58001L12.2566 11.0972L10.0742 13.3186C9.91832 13.4647 9.84034 13.6986 9.84034 13.9324C9.84034 14.4196 10.2106 14.7703 10.688 14.7703C10.9218 14.7703 11.1264 14.6826 11.3213 14.4975L17.8004 8.03792C17.9952 7.85281 18.0926 7.62872 18.0926 7.38514Z" fill="#777" />
                  </svg>
                </div>
                <div class="text-center">
                  <p class="mb-0 body-3">Check-out</p>
                  <p class="mb-0 text-16 font-lato">{{$formatDateWithoutMonth(getBeFilter.date.check_out)}}</p>
                </div>
              </div>
              <PerRoomCart 
                v-if="isMerchantMaldiveOhip" 
                @register-tr-ref="setTransportRouteRef" 
                @adjustPax="onBack('adjustPax', {
                  room_rate: $event,
                  valdiateAgeChild: false
                })"
              />
              <div class="w-100" v-else>
                <div v-for="(room_rate, rr_index) in getBeCart.room_rate_details" :class="{'mb-24px': rr_index+1 < getBeCart.room_rate_details.length}">
                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <p class="w-100 mb-0 body-2-4 text-truncate cursor-pointer">{{room_rate.room_rate.name}}</p>
                    <svg v-b-tooltip="'Remove Room'" class="cursor-pointer" @click="removeRoomRate(room_rate)" height="20" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4.96216 14.3925C4.67027 14.3925 4.48316 14.2204 4.46819 13.936L4.24366 5.69563C4.23617 5.41871 4.42328 5.23908 4.72266 5.23908C4.99958 5.23908 5.19418 5.41123 5.20166 5.68815L5.44116 13.936C5.44865 14.2129 5.25405 14.3925 4.96216 14.3925ZM7.24494 14.3925C6.953 14.3925 6.75093 14.2129 6.75093 13.936V5.69563C6.75093 5.41871 6.953 5.23908 7.24494 5.23908C7.53681 5.23908 7.74636 5.41871 7.74636 5.69563V13.936C7.74636 14.2129 7.53681 14.3925 7.24494 14.3925ZM9.53514 14.3925C9.24327 14.3925 9.04867 14.2129 9.05614 13.936L9.28817 5.69563C9.29564 5.41123 9.49024 5.23908 9.76717 5.23908C10.0665 5.23908 10.2536 5.41871 10.2462 5.69563L10.0216 13.936C10.0067 14.2204 9.81954 14.3925 9.53514 14.3925ZM3.95925 3.42037H5.14927V1.81871C5.14927 1.3921 5.44865 1.11517 5.89772 1.11517H8.57714C9.02619 1.11517 9.32559 1.3921 9.32559 1.81871V3.42037H10.5156V1.74387C10.5156 0.658628 9.81207 0 8.65946 0H5.81538C4.66278 0 3.95925 0.658628 3.95925 1.74387V3.42037ZM0.56133 4.01913H13.936C14.2428 4.01913 14.4898 3.75717 14.4898 3.45031C14.4898 3.14345 14.2428 2.88898 13.936 2.88898H0.56133C0.261954 2.88898 0 3.14345 0 3.45031C0 3.76466 0.261954 4.01913 0.56133 4.01913ZM3.81705 16.6678H10.6803C11.7505 16.6678 12.469 15.9717 12.5214 14.9014L13.0453 3.86196H1.44449L1.97588 14.909C2.02827 15.9792 2.73181 16.6678 3.81705 16.6678Z" fill="#DC3545"/>
                    </svg>
                  </div>
                  <div class="d-flex">
                    <div class="flex-shrink-0 light-box-shadow rounded-3 border-form h-auto" @click="onBack('detailRoom',room_rate)" style="width: 70px;">
                      <img
                        :src="$isNotEmpty(room_rate.room_rate.room_type.image) ? room_rate.room_rate.room_type.image[0].image_url : getMerchant.image_url" 
                        class="img-fit rounded-3 cursor-pointer">
                    </div>
                    <div class="w-100 pl-2-5">
                      <div class="w-100" @click="onBack('detailRoom',room_rate)">
                        <div class="d-flex align-items-center cursor-pointer lh-1 mb-1" >
                          <p v-if="isRoomDiscount(room_rate)" class="mb-0 text-12 text-subcolor font-lato-regular text-line-through mr-2">{{formatCurrency(calculateSubTotal(room_rate,false))}}</p>
                          <p class="mb-0 text-14 font-lato cursor-pointer text-orange">{{formatCurrency(calculateSubTotal(room_rate))}}</p>
                        </div>
                        <div class="d-flex align-items-center">
                          <span class="body-3 mb-0 flex-shrink-0" style="width: 40px;">Qty</span>  
                          <span class="body-3-3-2 mb-0">: {{room_rate.qty}} {{$t('hotel.unit-type.'+room_rate.room_rate.room_type.type+'.unit')}}</span>  
                        </div>
                        <div class="d-flex align-items-top">
                          <span class="body-3 mb-0 flex-shrink-0" style="width: 40px;">Guest</span>  
                          <span class="body-3-3-2 mb-0">: {{ filter_guest(room_rate.guest) }}</span>  
                        </div>
                      </div>
                      <p class="mb-0 font-lato ls-0-25 text-14 text-green cursor-pointer underline" @click="onBack('adjustPax',{
                        room_rate,
                        valdiateAgeChild: $v.cartRoomList.$each[rr_index].$error
                      })">Guest Details</p>
                    </div>
                  </div>
                  <p 
                    v-if="$v.cartRoomList.$each[rr_index].$error" 
                    class="w-100 body-3 text-danger mt-2" 
                    @click="onBack('adjustPax',{
                      room_rate,
                      valdiateAgeChild: $v.cartRoomList.$each[rr_index].$error
                    })">
                    Please provide the child’s age
                  </p>
                </div>
              </div>

              <div v-if="isUnderSearchPax" :class="{'px-3': isMerchantMaldiveOhip}">
                <div class="w-100 p-3 text-center border mt-3" style="background-color: rgb(255, 246, 243); border-color: rgb(254, 207, 184) !important;">
                  <p class="mb-0 body-2-1">{{isUnderSearchPax}}</p>
                </div>
              </div>
            </div>
            <template>
              <ProductCart @register-ref="setPrimaryRef"/>
            </template>
          </template>
          <div class="">
            <div class="row no-gutters">
              <div class="col-7">
                <p class="mb-1 body-2-2 text-white text-14 font-regular">{{getBeCart.qty.room_rate}} {{$t('hotel.unit-type.'+getBeRoomTypeSummaryType+'.unit')}} x {{totalDate}} {{$t("hotel.night")}}</p>
              </div>
              <div class="col-5 text-right">
                <p class="mb-1 body-2-2 text-white text-14 font-regular">{{formatCurrency(getBeRoomSubTotal)}}</p>
              </div>
              <template v-if="subtotalAdditionalService > 0">
                <div class="col-7">
                  <p class="mb-1 body-2-2 text-white text-14 font-regular">{{ `${$t('hotel.additional-service')}${totalTaxServiceAdditional > 0 ? '(Incl. Tax)' : ''}` }}</p>
                </div>
                <div class="col-5 text-right">
                  <p class="mb-1 body-2-2 text-white text-14 font-regular">{{formatCurrency(subtotalAdditionalService)}}</p>
                </div>
              </template>
              <div class="col-7 pt-2 my-2 border-light-top">
                <p class="mb-0 body-2-2 text-white text-14 font-regular">{{$t('hotel.concierge.discount')}}</p>
              </div>
              <div class="col-5 text-right pt-2 my-2 border-light-top">
                <p class="mb-0 body-2-2 text-white text-14 font-regular">{{ `${totalDiscount > 0 ? '-' : ''}${$formatCurrency(totalDiscount)}` }}</p>
              </div>
              <template v-if="$isNotEmptyV3(totalCurrentGreenTax)">
                <div class="col-7 mb-2">
                  <p class="mb-0 body-2-2 text-white text-14 font-regular">Green Tax</p>
                </div>
                <div class="col-5 mb-2 text-right">
                  <p class="mb-0 body-2-2 text-white text-14 font-regular">{{ $formatCurrency(totalCurrentGreenTax) }}</p>
                </div>
              </template>
              <div class="col-7 pb-2 mb-2 border-light-bottom">
                <p class="mb-0 body-2-2 text-white text-14 font-regular">{{$t('hotel.total-price')}}</p>
              </div>
              <div class="col-5 text-right pb-2 mb-2 border-light-bottom">
                <p class="mb-0 body-2-2 text-white text-14 font-regular">{{formatCurrency(total_price)}}</p>
              </div>
              <div class="col-12">
                <div class="row">
                  <template v-if="payment_surcharge > 0">
                    <div class="col-7">
                      <p class="mb-1 body-2-2 text-white text-14 font-regular">{{$t('hotel.payment-surcharge')}}</p>
                    </div>
                    <div class="col-5 text-right">
                      <p class="mb-1 body-2-2 text-white text-14 font-regular">{{formatCurrency(payment_surcharge)}}</p>
                    </div>
                  </template>
                  <div class="col-7">
                    <p class="mb-1 body-2-2 text-white text-14" :class="{'font-bold text-16':total_deposite_display > 0}">{{$t('hotel.deposit-due-now')}} <template v-if="total_deposit_merchant > 0">({{ getMerchant.deposit_zero_minimum_deposit_value }}%)</template></p>
                  </div>
                  <div class="col-5 text-right">
                    <p class="mb-1 body-2-2 text-white text-14" :class="{'font-bold text-16':total_deposite_display > 0}">{{formatCurrency(total_deposite_display)}}</p>
                  </div>
                  <div class="col-7">
                    <p class="mb-1 pb-1 mt-1 body-2-2 text-white text-14" :class="{'font-bold text-16':total_deposite_display == 0}">{{$t('hotel.deposit-due-on-arrival')}}</p>
                  </div>
                  <div class="col-5 text-right">
                    <p class="mb-1 pb-1 mt-1 body-2-2 text-white text-14" :class="{'font-bold text-16':total_deposite_display == 0}">{{formatCurrency(total_non_deposit)}}</p>
                  </div>
                </div>  
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="bg-white box-shadow-main rounded-6 px-4 py-4 mb-3" v-if="cart_step == 2 && this.getMerchant.use_changeable_deposit_value">
          <CustomDeposit :minimum_deposit="minimum_all_deposit" :total_order="total_price"></CustomDeposit>
        </div> -->
      </div>
    </transition>
	</div>
</template>
<script>
  import {mapGetters,mapMutations} from 'vuex'
  import {formatCurrency,formatDate} from '@/utils/index.js'
  import moment from 'moment';
  import CustomDeposit from '@/components/hotel/be/CustomDeposit'
  import ProductCart from '../additionalService/ProductCart';
  import PerRoomCart from '../PerRoomCart.vue';
  import { validationMixin } from "vuelidate";
  const { helpers, required } = require("vuelidate/lib/validators");

  const skipIfNoGuest = (type, validatorFn) =>
    helpers.withParams({ type: "skipIfNoGuest" }, function (value, parentVm) {
      const totalGuest = 
        (parentVm.included && parentVm.included[type] ? parentVm.included[type] : 0) +
        (parentVm.extra && parentVm.extra[type] ? parentVm.extra[type] : 0)
        
      
      if (totalGuest === 0) {
        return true
      }

      return validatorFn(value)
    })
  
	export default{
    props:{
      show_room: {
        type: Boolean,
        default: true
      },
      payment_surcharge:{
        type: Number,
        default: 0
      },
      payment_method:{
        type: Object,
        default: () => {}
      },
      total_deposit_merchant:{
        type: Number,
        default: 0
      },
      cart_step:{
        type: Number,
        default: 1
      }
    },
    components:{
      CustomDeposit,
      ProductCart,
      PerRoomCart
    },
    data(){
      return{
        data_room: ''
      }
    },
    computed:{
      ...mapGetters([
        'getMerchant',
        'getBeCartAddtService',
        'getBeCart',
        'getBeFilter',
        'getBeRoomSubTotal',
        'getBeRoomDeposit',
        'getBeAddtServiceDeposit',
        'getBeAddtServiceSubTotal',
        'getRoomAdditionalSubTotal',
        'getBeRoomTotal',
        'getBeRoomDiscount',
        'getBeRoomTypeSummaryType',
        'getActivityTrxTotal',
        'getOutletTrxTotal',
        'getVoucherOrderTotal',
        'isUnderSearchPax',
        'getActivityTrxSubTotal',
        'getOutletTrxSubTotal',
        'getVoucherOrderSubTotal',
        'getActivityTrxPromotion',
        'getOutletTrxPromotion',
        'getVoucherOrderTotalPromo',
        'getActivityTrxTaxService',
        'getOutletTrxTaxService'
      ]),
      isMerchantMaldiveOhip(){
        const { country = 'Indonesia', cm_reference = '' } = this.getMerchant;
        
        return country === 'Maldives' && cm_reference === 'OHIP';
      },
      totalTaxServiceAdditional(){
        return Number(this.getActivityTrxTaxService) + Number(this.getOutletTrxTaxService)
      },
      subtotalAdditionalService(){
        const subTotal = this.getBeAddtServiceSubTotal + Number(this.getActivityTrxSubTotal) + Number(this.getOutletTrxSubTotal) + Number(this.getVoucherOrderSubTotal) + Number(this.getRoomAdditionalSubTotal)
        
        return subTotal + this.totalTaxServiceAdditional;
      },
      promotionAdditionalService() {
        return -(
          Number(this.getActivityTrxPromotion) +
          Number(this.getOutletTrxPromotion) +
          Number(this.getVoucherOrderTotalPromo)
        );
      },
      totalDiscount(){
        return Number(this.getBeRoomDiscount) + Number(this.promotionAdditionalService);
      },  
      taxAdditionalService() {
        return (
          Number(this.getActivityTrxTaxService) +
          Number(this.getOutletTrxTaxService)
        );
      },
      total_additional_service(){
        let total = this.getBeAddtServiceSubTotal+this.$totalAddtServiceModule()+Number(this.getRoomAdditionalSubTotal)
        return total
      },
      showTax(){
        return this.getMerchant.search_room_is_show_tax_fee_note;
      },
      total_price(){
        return this.getBeRoomTotal
        + this.total_additional_service
        + this.totalCurrentGreenTax
      },
      total_deposit(){
        let total = this.getBeRoomDeposit
        + this.totalGreenTax.deposit
        + this.getBeAddtServiceDeposit
        + this.$totalAddtServiceModule()
        + Number(this.getRoomAdditionalSubTotal)

        const { bank_name = "", payment_method = "" } = this.payment_method;
        const isXenditCC = Object.keys(this.payment_method).length > 0 
        && bank_name == 'XENDIT' 
        && payment_method == 'CREDIT_CARD'
        
        return isXenditCC ? Math.ceil(total) : total;
      },
      total_deposite_display(){
        let total = this.total_deposit_merchant > 0 ? this.total_deposit_merchant : this.total_deposit
        if(this.payment_surcharge > 0){
          total += this.payment_surcharge
        }
        return total
      },
      minimum_all_deposit(){
        if(this.total_deposit == 0){
          return this.total_deposit_merchant
        }else{
          return this.total_deposit < this.total_deposit_merchant ? this.total_deposit : this.total_deposit_merchant
        }
      },
      total_non_deposit(){
        let deposit = this.total_deposit_merchant > 0 ? this.total_deposit_merchant : this.total_deposit
        let total = this.total_price-deposit
        if(Object.keys(this.payment_method).length > 0 && this.payment_method.bank_name == 'XENDIT' && this.payment_method.payment_method == 'CREDIT_CARD'){
          return Math.ceil(total)
        }
        return total
      },
      totalDate() {
        var diff = 0
        let check_in = moment(this.getBeFilter.date.check_in).format("YYYY-MM-DD")
        let check_out = moment(this.getBeFilter.date.check_out).format("YYYY-MM-DD")
        diff = moment(check_out).diff(moment(check_in)) / (1000 * 3600 * 24)
        return diff
      },
      totalGreenTax(){
        return this.$greenTaxes();
      },
      totalCurrentGreenTax(){
        return this.totalGreenTax.deposit + this.totalGreenTax.pay_later;
      },
      totalNight(){
        const { check_in, check_out } = this.getBeFilter.date;
        return this.$countDays(check_in, check_out)
      },
      cartRoomList(){
        return JSON.parse(JSON.stringify(this.getBeCart.room_rate_details));
      }
    },
    mixins: [validationMixin],
    validations: {
      cartRoomList: {
        $each: {
          guest: {
            $each: {
              age:{
                requiredChildAge: skipIfNoGuest('child',
                  v => v !== undefined
                ),
                requiredInfantAge: skipIfNoGuest('infant',
                  v => v !== undefined
                ),
                child:{
                  $each: {
                    requiredArray: skipIfNoGuest('child',
                      v => Array.isArray(v)
                    ),
                    notEmpty: skipIfNoGuest('child',
                      v => Array.isArray(v) && v.length > 0 && v.every(val => val !== "")
                    )
                  }
                },
                infant:{
                  $each: {
                    requiredArray: skipIfNoGuest('infant',
                      v => Array.isArray(v)
                    ),
                    notEmpty: skipIfNoGuest('infant',
                      v => Array.isArray(v) && v.length > 0 && v.every(val => val !== "")
                    )
                  }
                }
              }
            }
          }
        }
      }
    },
    methods:{
      ...mapMutations(['beRemoveRoomRate','changeBeRoomAvbl','BeRemoveAddtService']),
      setPrimaryRef(ref) {
        this.$emit('register-ref', ref)
      },
      setTransportRouteRef(ref){
        this.$emit('register-tr-ref', ref)
      },
      formatCurrency(value){
        return formatCurrency(value);
      },
      formatDate(date){
        return formatDate(date);
      },
      calculateSubTotal(data,with_discount=true){
        let total = 0
        for(let i=0 ; i < data.qty; i++){
          const guest = data.guest[i];
          
          for(let date of data.room_rate.dates){
            let total_extra = {
              adult: data.guest[i].extra.adult*date.extra_guest.adult.amount,
              child: data.guest[i].extra.child*date.extra_guest.child.amount,
              infant: data.guest[i].extra.infant*date.extra_guest.infant.amount,
            }
            let total_extra_price = total_extra.adult+total_extra.child+total_extra.infant
            
            let base_price = with_discount ? date.price+date.promotion_price : date.price
            if(this.$isNotEmptyV3(guest.price_display)){
              const { price, promotion_price } = guest.price_display;
              base_price = with_discount ? price + promotion_price : price
            }
            
            if(total_extra_price > 0){
              total += (base_price+total_extra_price)
            }else{
              total += base_price
            }
          }
        }
        return total
      },
      isRoomDiscount(data){
        let total = 0
        for(let date of data.room_rate.dates){
          total += date.promotion_price
        }
        return total < 0
      },
      onBack(type, data){
        this.$emit(type, data)
      },
      removeRoomRate(cart){
        this.beRemoveRoomRate(cart.room_rate.id);
        let roomtype_params = {
          id: cart.room_rate.room_type.id,
          rr_id: cart.room_rate.id,
          qty: cart.qty,
          action: 'inc',
          is_virtual: cart.room_rate.room_type.is_virtual,
          availability_affected: cart.room_rate.room_type.availability_affected
        }
        this.changeBeRoomAvbl(roomtype_params);
      },
      filter_guest(room_rate){
        let total_guest = {
          adult: 0,
          child: 0,
          infant: 0,
          extra: 0
        }
        room_rate.forEach(item=>{
          total_guest.adult += item.included.adult
          total_guest.child += item.included.child
          total_guest.infant += item.included.infant
          total_guest.extra += (item.extra.adult+item.extra.child+item.extra.infant)
        })
        let container = []
        if(total_guest.adult > 0){
          container.push(total_guest.adult+' '+ this.$t('hotel.adults.adults'))
        }
        if(total_guest.child > 0){
          container.push(total_guest.child+' '+ this.$t('hotel.children.children'))
        }
        if(total_guest.infant > 0){
          container.push(total_guest.infant+' '+ this.$t('hotel.infants.infants'))
        }
        if(total_guest.extra > 0){
          container.push(`${total_guest.extra} ${this.$pluralWord(total_guest.extra,this.$t('hotel.extra-guest'))}`)
        }

        let display = ''
        for(let i = 0; i < container.length; i++){
          if((i+1) == container.length){
            display += container[i]
          }else{
            display += (container[i]+', ')
          }
        }

        return display
      },
      removeAddtService(product){
        this.BeRemoveAddtService(product)
      },
      validateChildAge(){
        this.$v.$reset();
        this.$v.$touch();
        if (this.$v.$invalid) {
          const indexNotValid = Object.values(this.$v.cartRoomList.$each.$iter).findIndex(parent => parent.$error);
          if(indexNotValid != -1){
            let roomRateSelected = this.cartRoomList[indexNotValid];

            if(this.isMerchantMaldiveOhip){
              const roomSelectedValidation = this.$v.cartRoomList.$each.$iter[indexNotValid];
              const indexNotValidChild = Object.values(roomSelectedValidation.guest.$each.$iter).findIndex(child => child.$error);
              if(indexNotValidChild !== -1) Object.assign(roomRateSelected, { guestIndex: indexNotValidChild})
            }

            this.onBack('adjustPax',{
              room_rate: roomRateSelected,
              valdiateAgeChild: true
            })
          }
          return false
        }
        return true
      }
    },
	}
</script>
<style scoped>
  @media screen and (max-width: 1050px) {
    .text-14{
      font-size: 12px!important;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/hotel/be/desktop/cart.vue